// OVERRIDE ChatVibe — ver docs/modifications/2026-09-12-i18n-somente-en-pt_BR.md
//
// O upstream importa estaticamente os 42 idiomas do painel, o que coloca
// ~11,7 MB de traduções (minificadas, sem gzip) no chunk inicial que a tela
// de login já baixa. Mantemos apenas os idiomas usados pelos nossos clientes.
// Idioma ausente cai no fallback do vue-i18n (inglês), sem chaves cruas.
//
// Para habilitar outro idioma: adicionar o import + a chave abaixo e rebuildar.
import en from './locale/en';
import pt_BR from './locale/pt_BR';

export default {
  en,
  pt_BR,
};
